import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-progress-spinner",
  standalone: false,
  templateUrl: "./progress-spinner.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./progress-spinner.component.scss"],
})
export class ProgressSpinnerComponent implements OnInit {
  @Input() isLoading: boolean = false;
  @Input() showText: boolean = false;
  constructor() {}

  ngOnInit() {}
}
